import type { TPermissionAction } from '@/shared/features/permissions/actions';
import type { TPermissionCheck } from '@/shared/features/permissions/permission-check.types';

export const GENERAL_SETTINGS_PERMISSIONS = {
  manageCompany: 'ident:updateTenant',
  integrations: 'integration:readIntegration',
  tags: 'tag:readTag',
  backupLifecycle: 'ident:updateTenant',
  ideaas: 'ideaas:readSessionRecording',
  webhooks: 'webhook:readWebhook',
} as const satisfies Record<string, TPermissionAction>;

export const GENERAL_SETTINGS_PERMISSION_ACTIONS: TPermissionAction[] = [
  GENERAL_SETTINGS_PERMISSIONS.manageCompany,
  GENERAL_SETTINGS_PERMISSIONS.integrations,
  GENERAL_SETTINGS_PERMISSIONS.tags,
  GENERAL_SETTINGS_PERMISSIONS.ideaas,
  GENERAL_SETTINGS_PERMISSIONS.webhooks,
];

export const GENERAL_SETTINGS_PERMISSION: TPermissionCheck = {
  action: GENERAL_SETTINGS_PERMISSION_ACTIONS,
  any: true,
};
